import yup from 'yup';
// translate
import messages from './messages';

export default yup.object({
  login: yup.string().required(messages.validationRequiredLogin),
  password: yup.string().required(messages.validationRequiredPassword),
});



// WEBPACK FOOTER //
// ./src/components/Login/formRules.js